// ...existing imports...
import React from "react";
import { List, Typography, Button, Input, Row, Col, Pagination, Empty, Popconfirm, message } from "antd";
import { DeleteOutlined, EyeOutlined, EyeInvisibleOutlined, DownloadOutlined, ClockCircleOutlined, WarningOutlined, StopOutlined } from '@ant-design/icons';
import { optimizePhases } from "../../apis";
import axios from "axios";
import '../../styles/components/tables.css';

// Utility: Safe JSON.stringify to avoid circular reference errors
function safeStringify(obj) {
  const seen = new WeakSet();
  return JSON.stringify(obj, function(key, value) {
    if (typeof value === "object" && value !== null) {
      if (seen.has(value)) return "[Circular]";
      seen.add(value);
    }
    return value;
  });
}

// Utility: Safe Array.isArray to avoid stack overflow on circular structures
function safeIsArray(val) {
  try {
    return Array.isArray(val);
  } catch {
    return false;
  }
}


const { Text } = Typography;

const TabellaRiassuntiva = ({ flussi, onSelect, onDelete, onDeleteAll, onHover, onOptimize, optimizedData, conflittiSelezionati,setOptimizedData }) => {
  // console.log("this is flussi = ", flussi);
  const [visibilitaManovre, setVisibilitaManovre] = React.useState({});
const handleDeleteAllConfirm = (e) => {
  if (onDeleteAll) {
      onOptimize(null);
      onDeleteAll();
    }
    message.success('Tutte le manovre sono state eliminate');
  };

  const handleDeleteAllCancel = (e) => {
    message.error('Eliminazione annullata');
  };

  const handleDeleteManovra = (flusso) => {
    if (onDelete) {
      onDelete(flusso.id);
    }

    const removeDecoratorEvent = new CustomEvent("delete-decorator", {
      detail: flusso.latlngs,
    });
    window.dispatchEvent(removeDecoratorEvent);

    const removePolylineEvent = new CustomEvent("delete-manovra", {
      detail: flusso.latlngs,
    });
    window.dispatchEvent(removePolylineEvent);
  };

  const toggleVisibilita = (flusso) => {
    const id = flusso.id;
    const isVisible = !visibilitaManovre[id];
    setVisibilitaManovre((prev) => ({ ...prev, [id]: isVisible }));

    const event = new CustomEvent("toggle-visibility", {
      detail: {
        latlngs: flusso.latlngs,
        visible: isVisible,
      },
    });
    window.dispatchEvent(event);
  };

  const filteredFlussi = flussi.filter(f => f.data?.saved);
  const orderedFlussi = [...filteredFlussi].sort((a, b) => a.id - b.id); // oppure b.id - a.id

  const dataSource = filteredFlussi.map((flusso, index) => ({
    key: index,
    title: flusso.data?.title || `Manovra ${index + 1}`,
    latlngs: flusso.latlngs,
    tipo: flusso.data?.inputType || "",
  }));

  const [costanti, setCostanti] = React.useState({
    tempoCiclo: "90",
    tempoGiallo: "5",
    tempoRosso: "2",
  });

  const [currentPage, setCurrentPage] = React.useState(1);
  const pageSize = 10;
  const [loading, setLoading] = React.useState(false);

  const handleShowJson = async () => {
    const result = {
      Tc: Number(costanti.tempoCiclo),
      tempogiallo: Number(costanti.tempoGiallo),
      tempotuttorosso: Number(costanti.tempoRosso),
      fasi: filteredFlussi.map((flusso) => {
        const base = {
          nome: flusso.data?.title || "",
          tipo: flusso.data?.inputType || "",
        };

        if (flusso.data?.inputType === "veicolare") {
          const flussoTot = safeIsArray(flusso.data.flussi)
            ? flusso.data.flussi.reduce((sum, f) => sum + Number(f.value || 0), 0)
            : 0;

          return {
            ...base,
            flusso: flussoTot,
            cap_sat: Number(flusso.data.capSatResult) || 1200,
          };
        } else if (flusso.data?.inputType === "pedonale") {
          return {
            ...base,
            verde_min_ped: Number(flusso.data?.verdeMin) || 0,
          };
        }
        return base;
      }),
      conflitti: conflittiSelezionati || [],
    };


    try {
      setLoading(true);
      const apiResponse = await optimizePhases(result);
      onOptimize(apiResponse);
    } catch (error) {
      console.error("Errore nella chiamata all'API:", error);
    } finally {
      setLoading(false);
    }
  };

  const paginatedData = dataSource.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  return (
    <div className="table-container">
      <div className="table-constants-section">
        <Row gutter={[16, 8]}>
          {["tempoCiclo", "tempoGiallo", "tempoRosso"].map((field, idx) => (
            <React.Fragment key={field}>
              <Col span={16} className="table-constants-label">
                <span>
                  {field === "tempoCiclo" && <ClockCircleOutlined className="table-constants-icon" />}
                  {field === "tempoGiallo" && <WarningOutlined className="table-constants-icon-yellow" />}
                  {field === "tempoRosso" && <StopOutlined className="table-constants-icon-red" />}
                  {`Tempo ${field.replace("tempo", "")}:`}
                </span>
              </Col>
              <Col span={8}>
                <Input
                  type="number"
                  value={costanti[field]}
                  onChange={(e) => setCostanti((prev) => ({ ...prev, [field]: e.target.value }))}
                  size="small"
                />
              </Col>
            </React.Fragment>
          ))}
        </Row>
      </div>
      <div className="table-actions">
   <Popconfirm
          title="Elimina tutte le manovre"
          description="Sei sicuro di voler eliminare tutte le manovre?"
          onConfirm={handleDeleteAllConfirm}
          onCancel={handleDeleteAllCancel}
          okText="Sì"
          cancelText="No"
        >
          <Button
            danger
            className="table-delete-button"
            title="Elimina tutte le manovre"
          >
            <DeleteOutlined />
          </Button>
        </Popconfirm>

        <Button
          loading={loading}
          className="table-download-button"
          onClick={async () => {
            setLoading(true);
            await downloadManovreExcel();
            setLoading(false);
          }}
          title="Scarica manovre"
        >
          <DownloadOutlined />
        </Button>
      </div>

      <div className="table-list-container">
        <List
          dataSource={paginatedData}
          renderItem={(item, idx) => (
            <List.Item
              actions={[
                <DeleteOutlined
                  key="delete"
                  className="table-list-item-actions"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDeleteManovra(filteredFlussi[(currentPage - 1) * pageSize + idx]);
                  }}
                />
              ]}
              onMouseEnter={() => onHover?.(flussi[(currentPage - 1) * pageSize + idx])}
              onMouseLeave={() => onHover?.(null)}
              onClick={() => onSelect?.(flussi[(currentPage - 1) * pageSize + idx])}
              className="table-list-item"
            >
              <div>
                {item.title}
                {item.tipo ? ` - ${item.tipo.charAt(0).toUpperCase() + item.tipo.slice(1)}` : ""}
              </div>
            </List.Item>
          )}
          locale={{
            emptyText: (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description="No data"
                className="table-empty-state"
              />
            ),
          }}
        />
      </div>

      <Pagination
        current={currentPage}
        pageSize={pageSize}
        total={dataSource.length}
        onChange={setCurrentPage}
        className="table-pagination"
      />

      {filteredFlussi.length > 0 && (
        <div className="table-optimize-section">
          <Button
            type="primary"
            onClick={handleShowJson}
            loading={loading}
            className="table-optimize-button"
          >
            Ottimizza fasi
          </Button>
        </div>
      )}
      
{optimizedData && (
  <div className="table-results-container">
    <div className="table-results-header">
      📊 Risultati
    </div>

    <div>
      {Object.entries(optimizedData).map(([key, value]) => (
        <div
          key={key}
          className="table-results-section"
        >
          <div className="table-results-section-header">
            {key}
          </div>

          {typeof value === "object" && value !== null ? (
            safeIsArray(value) ? (
              <table className="table-results-table">
                <tbody>
                  {value.map((item, index) => (
                    <React.Fragment key={index}>
                      <tr className="table-results-table-row">
                        <td colSpan="2" className="table-results-table-cell-header">
                          Fase {index + 1}
                        </td>
                      </tr>
                      {typeof item === "object" && Object.entries(item).map(([subKey, subVal]) => {
                        if (subKey === "verde_min_ped" && item.tipo !== "pedonale") {
                          return null;
                        }
                        return (
                          <tr key={subKey} className="table-results-table-row">
                            <td className="table-results-table-cell-key">
                              {subKey}
                            </td>
                            <td className="table-results-table-cell-value">
                              {typeof subVal === "object" ? safeStringify(subVal) : subVal?.toString()}
                            </td>
                          </tr>
                        );
                      })}
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            ) : (
              <table className="table-results-table">
                <tbody>
                  {Object.entries(value).map(([subKey, subVal]) => (
                    <tr key={subKey}>
                      <td className="table-results-table-cell-key">
                        {subKey}
                      </td>
                      <td className="table-results-table-cell-value">
                        {typeof subVal === "object" ? safeStringify(subVal) : subVal?.toString()}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )
          ) : (
            <div className="table-results-simple-value">{value?.toString()}</div>
          )}
        </div>
      ))}
    </div>
  </div>
)}
    </div>
  );
};

export default TabellaRiassuntiva;

export const downloadManovreExcel = async () => {
  try {
    const response = await axios.get(process.env.REACT_APP_API_URL +`/api/manovra/excel`, {
      responseType: 'blob',
    });

    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = `manovra_.xlsx`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(downloadUrl);
  } catch (error) {
    console.error('Failed to download Excel file:', error);
  }
}